module.exports = __webpack_public_path__ + "static/media/9784020011644828575sdelux.b639f07b.jpg";